export const BRAND = "ConsciousLearn";
export const EDITION = "Georgia Edition";
export const EDITIONS = { ga: "Georgia Edition", fl: "Florida Edition", al: "Alabama Edition" };
export const STATE_NAMES = { ga: "Georgia", fl: "Florida", al: "Alabama" };
export const COPYRIGHT = `© ${BRAND} 2026. All rights reserved.`;

export const PrintFooter = () => (
  <div className="print-footer hidden print:block" data-testid="print-copyright-footer">{COPYRIGHT}</div>
);
